import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { MenuItem, Box, Select } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as ViewSelectors from 'selectors/ViewSelectors';

interface MenuItemType {
	value: string;
	text: string;
}

interface Props {
	type: 'status' | 'payment' | 'prepared';
	onChangeEvent: (event: any) => void;
	menuItems: MenuItemType[];
}

const RentalSearchFilterDropdown = (props: Props) => {
	const { type, onChangeEvent, menuItems } = props;
	const [statusAnchorEl, setStatusAnchorEl] = useState<null | HTMLElement>(null);
	const classes = useStyles();
	const filterStatus = useSelector(ViewSelectors.filterStatus);
	const value =
		type === 'status'
			? filterStatus.confirmed
			: type === 'payment'
			? filterStatus.payment
			: filterStatus.prepared;
	return (
		<Box className={classes.filterWrapper}>
			<Select
				ref={setStatusAnchorEl}
				className={classes.select}
				disableUnderline
				variant="standard"
				value={value}
				onChange={onChangeEvent}
				inputProps={{
					name: type,
					id: type,
				}}
				classes={{
					select: classes.selectDiv,
				}}
				MenuProps={{
					anchorEl: statusAnchorEl,
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'right',
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'right',
					},
					className: classes.menu,
				}}
			>
				{menuItems.map((menuItem) => {
					return (
						<MenuItem key={menuItem.value} value={menuItem.value}>
							{menuItem.text}
						</MenuItem>
					);
				})}
			</Select>
		</Box>
	);
};

const useStyles = makeStyles((theme) => {
	const border = `1px solid ${theme.palette.colors.tundra.main}`;
	return createStyles({
		select: {
			color: theme.palette.common.black,
			height: 40,
			width: '100%',
		},
		filterWrapper: {
			flex: '0 1 auto',
			flexWrap: 'wrap',
			paddingLeft: theme.spacing(2),
			borderLeft: border,
			'@media (max-width:880px)': {
				flex: '1 0 auto',
			},
		},
		menu: {
			marginTop: 1,
		},
		selectDiv: {
			fontSize: 14,
			fontWeight: 400,
		},
	});
});

export default RentalSearchFilterDropdown;
